export const PRESENTLEVELS_EVENT_NAMES = {
  SUMMARY: {
    CLICKED_CATEGORY: 'Clicked Present Levels Category',
    DELETED_AREA: 'Deleted Present Level Area',
    CLICKED_ADD_AREA: 'Clicked Add Present Level Area Button',
    ADDED_AREA: 'Added Present Level Area',
    CLICKED_STANDARD_LINK: 'Clicked Standard Code Link',
  },
  SKILL_SELECTION: {
    CLICKED_SKILL: 'Clicked Present Levels Skill',
    HIGHER_GRADES: 'Clicked View Higher Grade Levels',
    LOWER_GRADES: 'Clicked View Lower Grade Levels',
    GENERATE: 'Generated Present Levels Statement',
  },
  ALIGNED_GOALS: {
    FETCHED: 'Fetched Aligned Goals',
    CLICKED: 'Clicked PLW Aligned Goal',
    BROWSE_MORE: 'Clicked PLW Browse More Goals In',
  },
  NEW_SESSION: {
    VIEWED: 'Viewed Present Levels Wizard',
    SUBMIT: 'Clicked Develop Present Levels'
  },
  COMPOSE_IOD: {
    CLICKED: 'Clicked Compose Impact of Disability Statement from Present Levels Wizard'
  },
  VIEWED_SHARED_STATEMENT: 'Viewed Shared Present Levels'
}